import { fetchBrands } from '../api/brands';

import { GET_USER_BRANDS } from '../constants/brands';

export const getBrands = () => async (dispatch) => {
  const brands = await fetchBrands();
  dispatch({
    type: GET_USER_BRANDS,
    payload: brands
  });
};
